<div class="report-wrapper">
  <div class="header">
    <img src="/img/Parent@2x.png" class="header-image">
    <div class="contact-info">
      <div style="font-weight:600">Royal New York</div>
      <div>661 Hadley Rd.</div>
      <div>South Plainfield, NJ 07080</div>
      <div>Phone: (908) 756-6400</div>
    </div>
    <h3>Bill of Lading</h3>
  </div>
  <hr />
  @if (Header) {
  <fieldset style="width:95%">
    <legend style="font-size:16px; font-weight:bold">Order # {{Header.OrderID}}</legend>
    <div class="order-information">
      <div class="data-column">
        <!-- 5.2.13: no Bill To section — intentionally omitted, same as the Delivery Order -->
        <div class="data"><div>Carrier:</div><div>{{Header.TruckerName}}</div></div>
        <div class="data"><div>PRO #:</div><div>{{Header.ProNumber}}</div></div>
        <div class="data"><div>Pickup:</div><div>{{Header.PickupDate | date:'MM-dd-yyyy':'UTC'}}</div></div>
        <div class="data"><div>From:</div><div>{{Header.WarehouseName}} · {{Header.LocationStreet}}, {{Header.LocationCity}}, {{Header.LocationState}}</div></div>
        <div class="data"><div>Ship To:</div><div>{{Header.CompanyName}} · {{Header.ShipToStreet}}, {{Header.ShipToCity}}, {{Header.ShipToState}} {{Header.ShipToZip}}</div></div>
      </div>
      <div class="data-column">
        <div class="data"><div>Freight Rate:</div><div>{{Header.TruckingRate}}</div></div>
        <div class="data"><div>Quote #:</div><div>{{Header.TruckingQuote}}</div></div>
      </div>
    </div>
  </fieldset>

  <fieldset style="width:95%">
    <legend style="font-size:14px; font-weight:bold">Items</legend>
    <table style="width:100%">
      <thead><tr><th style="text-align:left">Item</th><th style="text-align:left">Bags</th></tr></thead>
      <tbody>
        @for (item of LineItems; track item.InventoryID) {
        <tr><td>{{item.InventoryID}} · {{item.InventoryTypeName}}</td><td>{{item.TotalBags}}</td></tr>
        }
      </tbody>
    </table>
  </fieldset>

  <fieldset style="width:95%">
    <legend style="font-size:14px; font-weight:bold">Trucker Instructions</legend>
    <div>{{Header.BOLInstructions}}</div>
  </fieldset>
  }

  <div class="footer">
    <div style="font-size:10px; color:#888">This is a system-generated bill of lading retained for record-keeping purposes. Order #{{Header?.OrderID}}.</div>
  </div>
</div>
